import React from 'react';
import { Phone } from 'lucide-react';
export function Navbar() {
  return <nav className="bg-navy-900 py-4 px-4 sm:px-6 lg:px-8 border-b border-navy-800" data-id="element-113">
      <div className="container mx-auto max-w-7xl flex justify-between items-center" data-id="element-114">
        <img src="https://cdn.magicpatterns.com/uploads/c5UQRdDneeHuQcb2CfoPds/Level_Up_Insurance_Logo_New_BLK.png" alt="Level Up Insurance" className="h-8 sm:h-10 object-contain brightness-0 invert" data-id="element-115" />
        <a href="tel:+18000000000" onClick={() => {
        if (typeof window !== 'undefined' && window.fbq) {
          window.fbq('track', 'Contact', {
            method: 'phone_call'
          });
          window.fbq('trackCustom', 'ClickToCall');
        }
      }} className="flex items-center gap-2 bg-green-500/15 hover:bg-green-500/25 text-green-400 hover:text-green-300 px-4 py-2 rounded-full transition-colors" data-id="element-116">
          <Phone className="w-4 h-4 sm:w-5 sm:h-5 fill-current" data-id="element-117" />
          <span className="font-bold text-sm sm:text-base tracking-wide" data-id="element-118">
            LLAMA AHORA
          </span>
        </a>
      </div>
    </nav>;
}